import { create } from 'zustand'

import type { LoadingBlockAppSlice } from './loading-block-app-slice'
import { createLoadingBlockAppSlice } from './loading-block-app-slice'

const useLoadingBlockStore = create<LoadingBlockAppSlice>()((...a) => ({
  ...createLoadingBlockAppSlice(...a)
}))

export default useLoadingBlockStore
